// 서비스 파일 구조

import { api } from "@/comn";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { TFormSchema, TGridSchema, useFetch } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";

/*
 * Customs Management service
 * !== 세관관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/mypage/todo`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/mypage/todo`,
    nodes: [
        { path: "/", label: "L_INT_PTL" },
        { path: "/", label: "L_MY_PGE" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0301001q: `${BASE.path}/ptli0301001q`, // My to-do List !== 나의 할일 목록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View my to-do list !== 나의 할일 목록 조회 ==!
    getTodoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getTodoBsopTpList: () => {
        return api.get(`${BASE.api}/bsop-tp-list`, {});
    },
};

export const SF_TODO_SRCH: TFormSchema = {
    id: "form_TodoSrch",
    schema: {
        frstRgsrDtm: {
            type: "daterange",
            label: "L_DT_RGSR",
            start: { name: "frstRgsrDtmFrom" },
            end: { name: "frstRgsrDtmTo" },
        },
        scrnDocCd: { type: "select", label: "L_TODO_BSOP_TP" },
        todoPrcdStatCd: { type: "select", label: "L_TODO_PRCD_STAT", area: "comnCd", comnCd: "OSC0099" },
        todoReffId: { type: "text", label: "L_TODO_REFF_ID" },
    },
};

export const SG_TODO_LIST: TGridSchema = {
    id: "grid_TodoList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_TODO_BSOP_TP", binding: "todoBsopDvn", width: "*" }] },
        { cells: [{ header: "L_TODO_REFF_ID", binding: "todoReffId", width: "20%" }] },
        { cells: [{ header: "L_TODO_PRCD_STAT", binding: "todoPrcdStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", align: "left" }] },
        { cells: [{ binding: "todoBsopDvn", align: "left" }] },
        { cells: [{ binding: "todoReffId", align: "left" }] },
        { cells: [{ binding: "todoPrcdStatCdNm" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};
